import { useAfterLaunch } from '../../productRouting/releaseConfig';
import { ROUTORA_PRO } from './pricing/routoraPro';
import usePageMetadata from './usePageMetadata';

// Search titles and descriptions for the public pages. Pages whose content
// changes at launch have a `launch` entry; the rest describe products that
// stay the same in every release mode.
const PAGES = {
  home: {
    path: '/',
    previous: {
      title: 'Routora | Route Optimization for Multiple Stops',
      description: 'Plan optimized routes for multiple stops on the web, iPhone and Android. Route planning and dispatching for individuals and teams.',
    },
    launch: {
      title: 'Routora | Inspection Route Planner',
      description: 'Plan the fastest route through your stops on the web, follow it on your phone, and document every visit with photos, notes and PDF reports. One Routora Pro subscription covers web and mobile.',
    },
  },
  pricing: {
    path: '/pricing',
    previous: {
      title: 'Pricing | Routora',
      description: 'Personal Workspace plans with a free trial, and the waitlist for the new Routora Team.',
    },
    launch: {
      title: 'Pricing | Routora',
      description: `Routora Pro is ${ROUTORA_PRO.price} a month, with a ${ROUTORA_PRO.trialDays}-day free trial for first-time subscribers. A new Routora Team is coming soon.`,
    },
  },
  webIntro: {
    path: '/web-intro',
    previous: {
      title: 'Routora on Web | Route Planner for Multiple Stops',
      description: 'Create an optimized route in less than 2 minutes with the Routora web route planner.',
    },
    launch: {
      title: 'Routora Pro | Route Planning and Inspection Reports',
      description: 'Plan the day’s inspections on the web, optimize the route, record results, photos and markup at each site in the Routora app, and share a PDF report when the route is done.',
    },
  },
  teams: {
    path: '/teams-intro',
    previous: {
      title: 'Routora Team | Plan and Dispatch Routes',
      description: 'Plan, assign, and optimize routes for your team in seconds, then dispatch them to your drivers’ phones.',
    },
  },
  teamsPricing: {
    path: '/pricing-teams',
    previous: {
      title: 'The New Routora Team | Coming Soon',
      description: 'The next version of Routora Team is coming soon. Join the waitlist and we’ll keep you posted as the launch gets closer.',
    },
  },
  extensionPricing: {
    path: '/pricing-extension',
    previous: {
      title: 'Chrome Extension Pricing | Routora',
      description: 'Optimize up to 10 stops in Google Maps with the free Routora Chrome extension.',
    },
    launch: {
      title: 'Chrome Extension Pricing | Routora',
      description: `Optimize up to 10 stops in Google Maps with the free Routora Chrome extension, or try Routora Pro free for ${ROUTORA_PRO.trialDays} days as a first-time subscriber.`,
    },
  },
  appInstall: {
    path: '/app-install',
    previous: {
      title: 'Get the Routora App | iPhone and Android',
      description: 'Download Routora for iPhone and Android to optimize your stops and navigate with Google Maps, Apple Maps or Waze.',
    },
    launch: {
      title: 'Get the Routora App | iPhone and Android',
      description: 'Download Routora for iPhone and Android: put the day’s inspections in the fastest order, record each result with photos, and share the PDF report from your phone.',
    },
  },
  government: {
    path: '/gov-intro',
    previous: {
      title: 'Routora for Government | Inspection Routing on ArcGIS',
      description: 'Field operations for inspection agencies: prioritize, assign, route and track every inspection on top of ArcGIS.',
    },
  },
};

export default function useMarketingPageMetadata(page) {
  const afterLaunch = useAfterLaunch();
  usePageMetadata(getMarketingPageMetadata(page, afterLaunch ? 'public' : 'prelaunch'));
}

export function getMarketingPageMetadata(page, mode) {
  const { path, previous, launch } = PAGES[page];
  const copy = mode !== 'prelaunch' && launch ? launch : previous;
  return { ...copy, path };
}
